import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { Row } from 'react-flexbox-grid';

export const ContinueAs = ({ user, app_url }) =>
  !(isNil(user) || isNil(app_url)) && (
    <Row center="xs">
      <a href={app_url}> Continue as {user}</a>
    </Row>
  );

ContinueAs.propTypes = {
  user: PropTypes.string,
  app_url: PropTypes.string
};

const mapStateToProps = state => ({
  user: state.authentication.username,
  app_url: state.authentication.app_url
});

export default connect(mapStateToProps, null)(ContinueAs);



// WEBPACK FOOTER //
// ./src/views/common/containers/ContinueAsContainer/index.jsx